import React from "react";
import useStrings from "../hooks/useStrings";

const Experience = ({ classicHeader, darkTheme }) => {
  const langStrings = useStrings();

  const experienceDetails = [
    {
      yearRange: "2021 - present",
      title: "Java/Kotlin Programmer",
      place: "Eika Gruppen AS, Warsaw/Oslo",
      desc: langStrings.experienceExp1Desc,
    },
    {
      yearRange: "2020 - 2021",
      title: "Java Spring Boot & Kotlin Programmer",
      place: "GISPartner Sp. z o.o., Wrocław/Warsaw",
      desc: langStrings.experienceExp2Desc,
    },
    {
      yearRange: "2020",
      title: "Java Spring Boot & Kotlin Programmer",
      place: "ZenCard Sp. z o.o., Warsaw",
      desc: langStrings.experienceExp3Desc,
    },
    {
      yearRange: "2019 - 2020",
      title: "IT Specialist",
      place: "KAMPOL S.J., Kamieńczyk",
      desc: langStrings.experienceExp4Desc,
    },
    {
      yearRange: "2015 - 2018",
      title: "System Analyst & Programmer",
      place: "Raiffeisen POLBANK, Warsaw",
      desc: langStrings.experienceExp5Desc,
    },
  ];

  return (
    <section
      id="experience"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24 text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {langStrings.experienceTitle}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {langStrings.experienceSubtitle}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end */}
        {experienceDetails.map((value, index) => (
          <div
            key={index}
            className={"rounded p-4 mb-4 " + (darkTheme ? "bg-dark" : "bg-white border")}
          >
            <p className="badge bg-primary text-2 fw-400">{value.yearRange}</p>
            <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>{value.title}</h3>
            <p className={darkTheme ? "text-primary" : "text-danger"}>{value.place}</p>
            <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>{value.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
